import type { PostHog } from 'posthog-js'

declare global {
  interface Window {
    posthog?: PostHog
  }
}

/**
 * Posthog is initialised once (only after the tracking cookie has been accepted) in the
 * `static` pack, which exposes the instance on `window`. Other packs capture through this
 * helper so they neither bundle posthog-js a second time nor send events without consent.
 */
export const capture = (event: string, properties: Record<string, unknown> = {}) => {
  window.posthog?.capture(event, properties)
}
